// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__hZDNS","button":"Menu_button__2Li99","dark":"Menu_dark__FjT6s","light":"Menu_light__3TSrH"};